import React from 'react'
import { Carousel } from 'react-bootstrap';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../Header/Header';
import TopNavbar from '../TopNavbar'
import Footer from '../../Footer/Footer'
// import banner10 from '../img/banner 10.png'
import b320 from '../img/b320.jpg'
import B1 from '../img/B1.jpg'
import AvanthyReddyBheemidi from '../img/AvanthyReddyBheemidi.jpeg'
import rajendrab3 from '../img/b3.jpg'

function B320() {
  return (
    <div>
      <Header />
      <TopNavbar />

      <div className="banner-area">
        <Carousel id="bootcarousel" className="text-light heading-uppercase animate_text" controls indicators={false}>
          {/* <Carousel.Item className="bg-cover img-fluid active">
        <img src={banner10} className="d-block w-100" alt="First slide" />
      </Carousel.Item> */}
          <Carousel.Item className="bg-cover img-fluid" style={{ padding: "30px" }}>
            <img src={b320} className="d-block w-100" alt="Second slide" />
          </Carousel.Item>
        </Carousel>
      </div>
      <br></br>
      <section id="about-us" className="about-us">
        <Container data-aos="fade-up">
          <div className="section-title">
            <h2>DG TEAM - DISTRICT 320B</h2>
          </div><br></br>
          <Row style={{ padding: "100px" }}>
            <Col lg={4} md={6} className="d-flex align-items-stretch">
              <div className="icon-box iconbox-blue">
                <div className="icon">
                  <img src={rajendrab3} style={{ width: '200px', height: '200px' }} alt="Salva Sairam Raju" />
                </div>
                <h4>Salva Sairam Raju</h4>
                <p style={{ color: "black" }}>District Governor <br /><br />Mobile:  9949013338</p>
              </div>

            </Col>
            <Col lg={4} md={6} className="d-flex align-items-stretch">
              <div className="icon-box iconbox-blue">
                <div className="icon">
                  <img src={B1} style={{ width: '200px', height: '200px' }} alt="Lion Shailaja Nair" />
                </div>
                <h4>Lion Shailaja Nair</h4>
                <p style={{ color: "black" }}>First Vice District Governor <br /><br />Mobile: 6281734230</p>
              </div>
            </Col>
            <Col lg={4} md={6} className="d-flex align-items-stretch">
              <div className="icon-box iconbox-blue">
                <div className="icon">
                  <img src={AvanthyReddyBheemidi} style={{ width: '200px', height: '200px' }} alt="DR Avanthy Reddy Bheemidi" />
                </div>
                <h4>DR Avanthy Reddy Bheemidi</h4>
                <p style={{ color: "black" }}>Second Vice District Governor <br /><br />Mobile: 99480 81106</p>
              </div>
            </Col>
          </Row>

          {/* <div className="section-title">
          <h2>GALLERY - DISTRICT 320B</h2>
        </div> */}
          {/* <Row>
          <Col lg={4} md={6} className="d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
            <div className="icon-box iconbox-blue">
              <div className="icon">
                <img src="https://lionsmd320.org/uploads/220705060710.jpg" style={{ width: '50%', cursor: 'zoom-in' }} alt="diabetes" title="diabetes" />
              </div>
              <span>diabetes</span>
            </div>
          </Col>

        </Row> */}
        </Container>
      </section><br></br>
      <Footer />
    </div>
  )
}

export default B320
